/**
 * User Properties Value Object
 * Represents user-specific properties for analytics tracking
 */
export class UserProperties {
    private constructor(
        public readonly userId?: string,
        public readonly userRole?: string,
        public readonly universityId?: string,
        public readonly universityName?: string,
        public readonly properties?: Record<string, any>
    ) { }

    static create(params: {
        userId?: string;
        userRole?: string;
        universityId?: string;
        universityName?: string;
        properties?: Record<string, any>;
    }): UserProperties {
        return new UserProperties(
            params.userId,
            params.userRole,
            params.universityId,
            params.universityName,
            params.properties
        );
    }

    /**
     * Convert to plain object for tracking
     */
    toTrackingData(): Record<string, any> {
        return {
            ...(this.userId && { user_id: this.userId }),
            ...(this.userRole && { user_role: this.userRole }),
            ...(this.universityId && { university_id: this.universityId }),
            ...(this.universityName && { university_name: this.universityName }),
            ...(this.properties && this.properties),
        };
    }
}
